import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RENTAL_STATUS, Rental } from 'src/app/models/verylys';
import { AbstractService, Pagination, PaginationResult, PopulateRequest } from '../abstract/abstract.service';
import { VlApiService } from '../vl-api/vl-api.service';
import { tap } from 'rxjs/operators';
import { CompanyPeriodicity } from 'src/app/models/verylys/companyPeriodicity.model';

@Injectable({
    providedIn: 'root'
})
export class RentalService extends AbstractService<Rental> {
    route = "/rentals/";
    resourceReferenceLabel = "Rental";

    protected crudMethods = {
        create: false,
        update: true,
        delete: false,
        get: true,
        getAll: true
    }

    protected cacheMethods = {
        get: true,
        getAll: true
    }

    /*public async getAll(config?: { populateRequest?: PopulateRequest | null, pagination?: Pagination | null }): Promise<PaginationResult<Rental>> {
      if (!this.crudMethods.getAll) {
        throw new Error($localize`:@@error.method-not-allowed:Method not allowed`);
      }
  
      let result: HttpResponse<Object> = await this.vlapi.get(`${this.route}?userId=me`, config);
      return result.body as PaginationResult<Rental>
    }*/

    public updateCustomLabel(rental: Rental, value: string): Observable<void> {
        return this.vlapi.patch<void>(`${this.route}${rental.friendly_id}/custom-name`, { value: value })
            .pipe(tap(() => {
                this.vlapi.invalidateEndpointRequest(this.route);
                this.vlapi.invalidateEndpointRequest(this.route + rental.friendly_id);
            }))
    }

    /**
     * Change the renewal periodicity of a rental
     * 
     * @rental           Rental to change the renewal time
     * @periodicity      The periodicity
     * 
     */
    public setRentalPeriodicity(rental: Rental, companyPeriodicity: CompanyPeriodicity): Observable<void> {
        return this.vlapi.post<any>(`${this.route}${rental.friendly_id}/set-periodicity`, { companyPeriodicityId: companyPeriodicity._id })
            .pipe(tap(() => {
                this.vlapi.invalidateEndpointRequest(this.route);
                this.vlapi.invalidateEndpointRequest(this.route + rental.friendly_id);
            }))
    }

    /**
     * Change the renewal payment fingerprint of a rental
     * 
     * @rental                Rental to change the renewal time
     * @paymentFingerprintId  Id of the paymentFingerprints
     * 
     */
    public setAutoRenewal(rental: Rental, paymentFingerprintId: string): Observable<void> {
        let body: any = {
            value: paymentFingerprintId
        }

        return this.vlapi.post<any>(`${this.route}${rental.friendly_id}/set-auto-renewal`, body)
            .pipe(tap(() => {
                this.vlapi.invalidateEndpointRequest(this.route);
                this.vlapi.invalidateEndpointRequest(this.route + rental.friendly_id);
            }))
    }

    /**
     * Remove the renewal payment fingerprint of a rental
     * 
     * @rental                Rental to change the renewal time
     * 
     */
    public removeAutoRenewal(rental: Rental): Observable<void> {
        return this.vlapi.delete<void>(`${this.route}${rental.friendly_id}/remove-auto-renewal`)
            .pipe(tap(() => {
                this.vlapi.invalidateEndpointRequest(this.route);
                this.vlapi.invalidateEndpointRequest(this.route + rental.friendly_id);
            }))
    }

    /**
     * Add a rental renwal to the cart
     * 
     * @param rental: Rental 
     */
    public addRenewToCart(rental: Rental): Observable<void> {
        return this.vlapi.post<void>(`${this.route}${rental.friendly_id}/add-renew-to-cart`);
    }

    public validate(value: Rental): void {

    }

    public normalizeStatus(rental: Rental): string {
        switch (rental?.parameters?.status?.value) {
            case RENTAL_STATUS.AVAILABLE:
                return $localize`:@@rental_status.available:Available`;
            case RENTAL_STATUS.CREATING:
                return $localize`:@@rental_status.creating:Creating`;
            case RENTAL_STATUS.SUSPENDED:
                return $localize`:@@rental_status.suspended:Suspended`;
            case RENTAL_STATUS.SUSPENDING:
                return $localize`:@@rental_status.suspending:Suspending`;
            default:
                return $localize`:@@rental_status.unknown:Unknown`;
        }
    }
}
